module.exports = __webpack_public_path__ + "assets/images/confirm-email.d41eee8db7930dc9ec92ded4b76e70ab.webp";